<template>
  <div
    component-name="btn-indoor-outdoor"
    data-skin="black"
    :inert="disabled || undefined"
  >
    <SwitchGroup
      class="transition-colors duration-300 ease-in-out rounded-full max-w-min h-9"
      :class="{
        'bg-white': !disableUnactive,
      }"
    >
      <div
        class="relative top-0 left-0 flex items-center overflow-hidden rounded-full z-2 gap-11 px-xl"
      >
        <div ref="tpl_wrapper" class="absolute inset-0 w-full h-full">
          <div
            class="relative top-0 h-full max-w-min px-xl rounded-full bg-skin-base will-change-[transform,left,width] transition-[transform,left,width] duration-500 ease-in-out"
            :class="{
              '-translate-x-px': isIndoor,
              '-translate-x-full': !isIndoor,
            }"
            :style="`left: ${isIndoor ? 0 : switchW + 2}px`"
          >
            <Switch
              v-model="isIndoor"
              class="h-full focus:outline-none will-change-[width] transition-[width] duration-500 ease-in-out"
              :style="`width: ${isIndoor ? indoorW : outdoorW}px; max-width: ${
                isIndoor ? indoorW : outdoorW
              }px`"
            />
          </div>
        </div>

        <SwitchLabel
          ref="tpl_indoor"
          :passive="isIndoor"
          class="relative top-0 left-0 flex items-center h-full text-right transition-colors duration-700 ease-in-out select-none z-2 text-button-small/none subpixel-antialiased"
          :class="{
            'text-skin-base': isIndoor,
            'text-skin-subtle hover:text-skin-inverse cursor-pointer':
              !isIndoor,
            hidden: disableUnactive && !isIndoor,
          }"
          >{{ $t.labels.indoor }}
        </SwitchLabel>

        <SwitchLabel
          ref="tpl_outdoor"
          :passive="!isIndoor"
          class="relative top-0 left-0 flex items-center h-full text-right transition-colors duration-700 ease-in-out select-none z-2 text-button-small/none subpixel-antialiased"
          :class="{
            'text-skin-base': !isIndoor,
            'text-skin-subtle hover:text-skin-inverse cursor-pointer': isIndoor,
            hidden: disableUnactive && isIndoor,
          }"
          >{{ $t.labels.outdoor }}</SwitchLabel
        >
      </div>
    </SwitchGroup>
  </div>
</template>

<script setup>
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";

const props = defineProps({
  indoor: {
    type: Boolean,
    required: false,
    default: true,
  },
  disableUnactive: {
    type: Boolean,
    required: false,
    default: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["update"]);
const isIndoor = ref(props.indoor ? true : false);
const tpl_indoor = ref();
const tpl_outdoor = ref();
const tpl_wrapper = ref();

const { width: switchW } = useElementSize(tpl_wrapper);
const { width: indoorW } = useElementSize(tpl_indoor);
const { width: outdoorW } = useElementSize(tpl_outdoor);

if (!props.disabled) {
  watch(isIndoor, (newVal) => {
    emit("update", newVal);
  });
}

watch(
  () => props.indoor,
  (newVal) => {
    isIndoor.value = props.indoor;
  }
);
</script>
